import { Breakpoint, useBreakpoint } from '../../utils/breakpoints';

const BreakpointContent = ({
  renderPhone,
  renderTablet,
  renderDesktop
}) => {
  const breakpoint = useBreakpoint();

  if (breakpoint === Breakpoint.PHONE) {
    return renderPhone();
  }

  if (breakpoint === Breakpoint.TABLET) {
    return renderTablet();
  }

  return renderDesktop();
};

export default BreakpointContent;